import { paths } from '@mc/paths'

import { CategoryNavCarousel as CategoryNavCarouselContent } from 'components/CategoryNavCarousel'

import { trackCategoryNavClicked } from '../../events'
import { usePageData } from '../PageDataProvider'

export const CategoryNavCarousel = () => {
  const { categories, slug } = usePageData()

  return (
    <CategoryNavCarouselContent
      categories={categories}
      slug={slug}
      pathCategory={paths.category}
      onNavClick={({ slug: categorySlug }) =>
        trackCategoryNavClicked(categorySlug)
      }
    />
  )
}
